import React from "react";

export const SyncForCommerceIcon: React.FC = () => {
  return (
    <svg
      data-testid="sync-for-commerce-icon"
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_1530_842)">
        <g clipPath="url(#clip0_1530_842)">
          <rect x="3" y="2" width="48" height="48.0001" rx="8" fill="#FDD655" />
          <rect
            x="35.123"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 35.123 2)"
            fill="#713B12"
          />
          <rect
            x="38.6738"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 38.6738 2)"
            fill="#713B12"
          />
          <rect
            x="31.5723"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 31.5723 2)"
            fill="#713B12"
          />
          <rect
            x="24.4727"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 24.4727 2)"
            fill="#713B12"
          />
          <rect
            x="20.9238"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 20.9238 2)"
            fill="#713B12"
          />
          <rect
            x="17.373"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 17.373 2)"
            fill="#713B12"
          />
          <rect
            x="51"
            y="34.127"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 34.127)"
            fill="#713B12"
          />
          <rect
            x="51"
            y="37.6758"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 37.6758)"
            fill="#713B12"
          />
          <rect
            x="51"
            y="30.5762"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 30.5762)"
            fill="#713B12"
          />
          <rect
            x="51"
            y="23.4766"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 23.4766)"
            fill="#713B12"
          />
          <rect
            x="51"
            y="19.9258"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 19.9258)"
            fill="#713B12"
          />
          <rect
            x="51"
            y="16.375"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 16.375)"
            fill="#713B12"
          />
          <g filter="url(#filter1_di_1530_842)">
            <rect
              x="7"
              y="6"
              width="40"
              height="40.0001"
              rx="6"
              fill="#1A0044"
            />
            <rect
              x="7.24859"
              y="6.24859"
              width="39.5028"
              height="39.5029"
              rx="5.75141"
              stroke="black"
              strokeOpacity="0.2"
              strokeWidth="0.49718"
            />
          </g>
          <path
            d="M33.7467 36.5007C33.7467 37.145 33.2244 37.6673 32.5801 37.6673C31.9358 37.6673 31.4134 37.145 31.4134 36.5007C31.4134 35.8563 31.9358 35.334 32.5801 35.334C33.2244 35.334 33.7467 35.8563 33.7467 36.5007Z"
            fill="white"
          />
          <path
            d="M24.4134 36.5007C24.4134 37.145 23.8911 37.6673 23.2467 37.6673C22.6024 37.6673 22.0801 37.145 22.0801 36.5007C22.0801 35.8563 22.6024 35.334 23.2467 35.334C23.8911 35.334 24.4134 35.8563 24.4134 36.5007Z"
            fill="white"
          />
          <path
            d="M15.0801 14.334H16.6039C16.891 14.334 17.0345 14.334 17.15 14.3868C17.2517 14.4333 17.338 14.5081 17.3984 14.6023C17.467 14.7091 17.4873 14.8512 17.5279 15.1353L18.0801 19.0007M22.4921 31.2507C21.3369 31.2507 21.2738 31.2507 20.81 31.0376C20.4013 30.8499 20.0557 30.548 19.8145 30.1684C19.5409 29.7376 19.463 29.1653 19.3073 28.0206L18.0801 19.0007M32.9907 31.2507C34.0904 31.2507 34.6402 31.2507 35.0895 31.0528C35.4857 30.8784 35.8256 30.5971 36.0711 30.2406C36.3495 29.8362 36.4524 29.2961 36.6581 28.2159L38.2024 20.1086C38.2748 19.7284 38.311 19.5383 38.2585 19.3897C38.2125 19.2594 38.1217 19.1496 38.0022 19.08C37.8661 19.0007 37.6726 19.0007 37.2855 19.0007H34.0852M18.0801 19.0007H23.0065M33.495 31.2508L26.143 31.2508M26.143 31.2508L28.4763 28.5986M26.143 31.2508L28.4763 33.903M21.1889 18.9952L30.2889 18.9952M30.2889 18.9952L27.9556 16.3429M30.2889 18.9952L27.9556 21.6474M24.4134 36.5007C24.4134 37.145 23.8911 37.6673 23.2467 37.6673C22.6024 37.6673 22.0801 37.145 22.0801 36.5007C22.0801 35.8563 22.6024 35.334 23.2467 35.334C23.8911 35.334 24.4134 35.8563 24.4134 36.5007ZM33.7468 36.5007C33.7468 37.145 33.2244 37.6673 32.5801 37.6673C31.9358 37.6673 31.4134 37.145 31.4134 36.5007C31.4134 35.8563 31.9358 35.334 32.5801 35.334C33.2244 35.334 33.7468 35.8563 33.7468 36.5007Z"
            stroke="white"
            strokeWidth="1.71429"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <rect
          x="3.21818"
          y="2.21818"
          width="47.5636"
          height="47.5637"
          rx="7.78182"
          stroke="black"
          strokeOpacity="0.2"
          strokeWidth="0.436364"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_1530_842"
          x="0.745718"
          y="0.497145"
          width="52.5086"
          height="52.5086"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.751427"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1530_842"
          />
          <feOffset dy="0.751427" />
          <feGaussianBlur stdDeviation="0.751427" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1530_842"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.751427" />
          <feGaussianBlur stdDeviation="1.12714" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1530_842"
            result="effect2_dropShadow_1530_842"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1530_842"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_di_1530_842"
          x="3"
          y="3"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1530_842"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1530_842"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.99436" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1530_842"
          />
        </filter>
        <clipPath id="clip0_1530_842">
          <rect x="3" y="2" width="48" height="48.0001" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
